import React, { useMemo, useState } from "react";
import FormInput from "../../../Components/Forms/FormInput/FormInput";

import { injectIntl, FormattedMessage, useIntl } from "react-intl";
import { createFormData } from "../../../Helpers/MiscHelper";
import { withSpace } from "../../../Contexts/SpaceContext";
import withSpaceEntityForm from "../../../Components/Forms";
import SideMenuForm from "../../../Components/Forms/SideMenuForm";
import { spaceProjectCategorySchema } from "../../../config/schema";
import {
  OrganizationDropdown
  //   DepartmentTeamDropdown,
  //   convertToDepartmentTeams,
  //   convertDepartmentTeams
} from "../../AdvancedMultiInputs";
// import FileUploader from "../../../Components/FileUploader/FileUploader";
import {
  BaseSidebarContainer,
  BaseSidebarHeader,
  BaseSidebarContent,
  useSidebarSpaceDelete
} from "../../../Components/Sidebar/SidebarV2Helper";
import Button from "../../../Components/Button/Button";
import LoadableButton from "../../../Components/Button/LoadableButton";
import { useToast } from "../../../Components/Toast/ToastProvider";
import { useHandleError } from "../../../Components/CGrid/ServerAwareHelper";

const ProjectCategoryForm = ({ refetchRef, ...props }) => {
  const { formStatus, isChild, form } = props;
  const [isDeleting, setIsDeleting] = useState(false);

  const { Id, CanDelete } = form;

  const footerComp = useMemo(() => {
    if (!Id)
      return (
        <div className="shadow-top px-3 py-3 of-y-auto d-flex align-items-center justify-content-between">
          <div></div>
          <LoadableButton
            type="button"
            isLoading={formStatus.isProcessing}
            onClick={formStatus.submit}
          >
            <FormattedMessage id={"CONFIRM"} />
          </LoadableButton>
        </div>
      );

    if (!isDeleting) {
      return (
        <div className="shadow-top px-3 py-3 of-y-auto d-flex align-items-center justify-content-between">
          {CanDelete ? (
            <Button
              type="button"
              vType="link-danger fw-bold"
              className="mr-3"
              onClick={() => setIsDeleting(true)}
            >
              <span style={{ fontWeight: 500 }}>
                <FormattedMessage id="DELETE" />
              </span>
            </Button>
          ) : (
            <div></div>
          )}
          <LoadableButton
            type="button"
            isLoading={formStatus.isProcessing}
            onClick={formStatus.submit}
          >
            <FormattedMessage id={"CONFIRM"} />
          </LoadableButton>
        </div>
      );
    } else
      return (
        CanDelete && (
          <RemovalFooter
            endpoint={`projecttypes/${Id}`}
            refetchRef={refetchRef}
            onCancel={() => setIsDeleting(false)}
          />
        )
      );
  }, [
    CanDelete,
    Id,
    formStatus.isProcessing,
    formStatus.submit,
    isDeleting,
    refetchRef
  ]);

  return (
    <BaseSidebarContainer>
      <BaseSidebarHeader>
        <FormattedMessage id="PROJECT_TYPE" />
      </BaseSidebarHeader>
      <BaseSidebarContent>
        <SideMenuForm footerComponent={footerComp} formStatus={formStatus}>
          <FormInput
            disabled={isChild}
            name="Organizations"
            className="mb-3"
            textId="COMPANIES_SUBSIDIARIES"
            inputType={OrganizationDropdown}
            multiple
          />

          <FormInput name="Type" textId="TYPE" optional className="mb-3" />

          <FormInput name="Name" textId="DESCRIPTION" className="mb-3" />

          {/* <FormInput name="Domain" textId="DOMAIN" className="mb-3" />

          <FormInput
            name="Files"
            textId="FILES"
            inputType={FileUploader}
            extendedMode
            className="mb-3"
          /> */}
        </SideMenuForm>
      </BaseSidebarContent>
    </BaseSidebarContainer>
  );
};

const RemovalFooter = ({ endpoint, refetchRef, onCancel }) => {
  const createToast = useToast();
  const intl = useIntl();
  const handleTranslatedError = useHandleError(spaceProjectCategorySchema);
  const [deleteUser, { loading }] = useSidebarSpaceDelete(
    endpoint,
    spaceProjectCategorySchema,
    {
      onSuccess: ({ data }) => {
        createToast({
          pos: "tm",
          type: "success",
          title: `${intl.formatMessage({ id: "PROJECT_TYPE" })}`,
          description: `${intl.formatMessage({ id: "SUCCESS_DELETED" })}`
        });
      },
      onError: ({ error }) => {
        handleTranslatedError(error);
      },
      refetchRef
    }
  );

  return (
    <div className="shadow-top px-3 py-3 of-y-auto d-flex align-items-center justify-content-between">
      <div className="text-black">
        <FormattedMessage id="ELIMINATE_PROJECT_CATEGORY" />
      </div>

      <div className="d-flex align-items-center">
        <Button
          type="button"
          vType="outline-danger"
          className="mr-3"
          onClick={onCancel}
        >
          <FormattedMessage id="BACK" />
        </Button>

        <LoadableButton
          vType="danger"
          isLoading={loading}
          onClick={() => {
            deleteUser();
          }}
        >
          <FormattedMessage id="DELETE" />
        </LoadableButton>
      </div>
    </div>
  );
};

export default withSpaceEntityForm(withSpace(injectIntl(ProjectCategoryForm)), {
  defaultForm: {
    Organizations: [],
    Type: "",
    Name: "",
    Domain: "",
    Files: []
  },
  validateForm: ({ Name }, addError) => {
    if (!Name) addError("Name");
  },
  convertEntityToForm: (entity) => {
    const { ...rest } = entity;

    return {
      ...rest
    };
  },
  onSuccess: (props) => {
    const { createToast, intl, form } = props;
    const { Name } = form;
    createToast({
      pos: "tm",
      type: "success",
      title: `${intl.formatMessage({ id: "PROJECT_TYPE" })} ${Name}`,
      description: `${intl.formatMessage({
        id: "SUCCESS_SAVED"
      })}`
    });
    // handleToast(props)
  },
  formatForm: (form) => {
    let { Files, Organizations, ...rest } = form;

    return createFormData(
      {
        ...rest,
        organizations: Organizations.length === 0 ? undefined : Organizations
      },
      Files
    );
  },
  schema: spaceProjectCategorySchema
  // getEntityId: (state, ownProps) => ownProps.projectCategoryId
});
